import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setDeleteCollectionProductModal } from "./DeleteCollectionProductModalSlice";
import { Translate } from "../../common/utils/Translate";
import {
    removeCollectionProductId,
    useLazyGetCollectionsQuery,
    useUpdateCollectionMutation,
} from "../../pages/collectionsPage/CollectionsSlice";
import { JSX, useEffect, useState } from "react";
import { useGetUserInfoQuery } from "../../app/rootReducer";
import { Modal, Button } from "@hatch-digital-nl/bravilor-storybook";
import { useStringTranslation } from "../../common/hooks/useStringTranslation";

export const DeleteCollectionProductModalContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();

    const userData = useGetUserInfoQuery();
    const { activeLanguage } = userData?.data || { activeLanguage: null };
    const { t } = useStringTranslation();

    const { collections } = useAppSelector((state) => state.collections);
    const { productId, collectionId } = useAppSelector(
        (state) => state.deleteCollectionProductModal,
    );

    const [loading, setLoading] = useState<boolean>(false);
    const [updateCollectionTrigger] = useUpdateCollectionMutation();
    const [collectionTrigger] = useLazyGetCollectionsQuery();

    const productName =
        collections
            .find((item: { id: number }) => item.id === collectionId)
            ?.productIds.find((item: { id: number }) => item.id === productId)
            ?.name || "";

    const paramObject = {
        collectionId: collectionId,
        collectionName:
            collections.find((item: { id: number }) => item.id === collectionId)
                ?.name || "",
        productIds:
            collections.find((item: { id: number }) => item.id === collectionId)
                ?.productIds || [],
    };

    useEffect(() => {
        dispatch(
            removeCollectionProductId({
                collectionId: collectionId,
                productId: productId,
            }),
        );
    }, [collectionId, dispatch, productId]);

    const handleClose = (): void => {
        dispatch(
            setDeleteCollectionProductModal({
                showPopup: false,
            }),
        );
    };

    return (
        <Modal onClose={handleClose} loading={loading}>
            <header className="c-modal__header">
                <h1>{t("do-you-want-to-delete-this-item")}</h1>
            </header>

            <div className="c-modal__body">
                {!!activeLanguage && (
                    <p>
                        {t(
                            "do-you-want-to-add-another-product-to-this-collection",
                        ) +
                            " " +
                            Translate(productName, activeLanguage)}
                        ?
                    </p>
                )}

                <div className="c-modal__body__buttons">
                    <Button
                        variant={"primary"}
                        onClick={() => {
                            setLoading(true);
                            updateCollectionTrigger(paramObject).then(() => {
                                collectionTrigger().then(() => {
                                    setLoading(false);
                                    dispatch(
                                        setDeleteCollectionProductModal({
                                            showPopup: false,
                                        }),
                                    );
                                });
                            });
                        }}
                    >
                        <span>{t("yes-im-sure")}</span>
                    </Button>
                    <Button
                        variant={"secondary"}
                        onClick={() => {
                            dispatch(
                                setDeleteCollectionProductModal({
                                    showPopup: false,
                                }),
                            );
                        }}
                    >
                        <span>{t("cancel")}</span>
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
